import type { UserCreateRequest } from '../../school/types';
import type { SchoolTeacherCreateRequest } from '../types';

// Tạo qua POST /user để giáo viên có tài khoản đăng nhập (user_name, mật khẩu);
// BE ghi school_users từ schoolId/classId, thông tin giảng dạy lưu ở metadata.
export const buildTeacherCreatePayload = (data: SchoolTeacherCreateRequest): UserCreateRequest => ({
  // Mã trống thì không gửi để BE tự sinh (GV001…)
  code: data.code?.trim() || undefined,
  name: data.name,
  email: data.email,
  phone: data.phone,
  user_name: data.user_name || '',
  role: 'teacher',
  type: 'teacher',
  schoolId: data.schoolId || undefined,
  classId: data.classId || undefined,
  metadata: {
    unit: data.unit,
    subjects: data.subjects,
    classification: data.classification,
    monthlyQuota: data.monthlyQuota,
    position: data.position,
    location: data.location,
    instructorType: data.instructorType,
    skills: data.skills,
    certifications: data.certifications,
    hourlyRate: data.hourlyRate,
    rating: data.rating,
    totalClasses: data.totalClasses,
  },
});
